// extracted by mini-css-extract-plugin
export default {"content":"ModalConfitm_content__gxwNk","button":"ModalConfitm_button__ijpcD"};